// extracted by mini-css-extract-plugin
export var divider = "_nd-0";
export var systemMessage = "_nd-1";